/**
 * Google Analytics 4 (GA4) Tracking Utility
 * Handles page view tracking and custom events for React Router
 */

// GA4 Measurement ID (Property ID: 478022915)
export const GA_MEASUREMENT_ID = 'G-478022915';

/**
 * Track a page view
 * @param {string} path - The path of the page
 * @param {string} title - The title of the page (optional)
 */
export const trackPageView = (path, title = '') => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('config', GA_MEASUREMENT_ID, {
      page_path: path,
      page_title: title || document.title,
    });
  }
};

/**
 * Track a custom event
 * @param {string} eventName - Name of the event
 * @param {object} eventParams - Additional event parameters
 */
export const trackEvent = (eventName, eventParams = {}) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', eventName, eventParams);
  }
};

/**
 * Track button clicks
 * @param {string} buttonName - Name/identifier of the button
 * @param {string} location - Where the button is located (e.g., 'header', 'hero', 'footer')
 */
export const trackButtonClick = (buttonName, location = '') => {
  trackEvent('button_click', {
    button_name: buttonName,
    button_location: location,
  });
};

/**
 * Track form submissions
 * @param {string} formName - Name of the form
 */
export const trackFormSubmission = (formName) => {
  trackEvent('form_submit', {
    form_name: formName,
  });
};

/**
 * Track language changes
 * @param {string} language - The language code (e.g., 'it', 'en')
 */
export const trackLanguageChange = (language) => {
  trackEvent('language_change', {
    language: language,
  });
};

/**
 * Track booking widget interactions
 * @param {string} action - The action performed (e.g., 'open', 'close', 'search')
 */
export const trackBookingWidget = (action) => {
  trackEvent('booking_widget_interaction', {
    widget_action: action,
  });
};

/**
 * Track WhatsApp button clicks
 */
export const trackWhatsAppClick = () => {
  trackEvent('whatsapp_click', {
    contact_method: 'whatsapp',
  });
};

/**
 * Track phone number clicks
 */
export const trackPhoneClick = () => {
  trackEvent('phone_click', {
    contact_method: 'phone',
  });
};

/**
 * Track email clicks
 */
export const trackEmailClick = () => {
  trackEvent('email_click', {
    contact_method: 'email',
  });
};

